export default "__VITE_ASSET__52b5ac93__"